export default {
      id: "https-ssl-usage",
      viewBox: "0 0 20 30",
      url: __webpack_public_path__ + "img/icons.svg#https-ssl",
      toString: function () {
        return this.url;
      }
    }